var BonusFieldNames = /* @__PURE__ */ ((BonusFieldNames2) => {
  BonusFieldNames2["bonusType"] = "bonusType";
  return BonusFieldNames2;
})(BonusFieldNames || {});
var BonusEvents = /* @__PURE__ */ ((BonusEvents2) => {
  BonusEvents2[BonusEvents2["FirstDeposit"] = 1] = "FirstDeposit";
  BonusEvents2[BonusEvents2["Deposit"] = 2] = "Deposit";
  BonusEvents2[BonusEvents2["Registration"] = 3] = "Registration";
  BonusEvents2[BonusEvents2["FreespinPlayed"] = 4] = "FreespinPlayed";
  BonusEvents2[BonusEvents2["InputCoupon"] = 5] = "InputCoupon";
  BonusEvents2[BonusEvents2["Scheduler"] = 6] = "Scheduler";
  BonusEvents2[BonusEvents2["GroupUpdated"] = 7] = "GroupUpdated";
  BonusEvents2[BonusEvents2["Manual"] = 8] = "Manual";
  BonusEvents2[BonusEvents2["PrizeAward"] = 9] = "PrizeAward";
  BonusEvents2[BonusEvents2["ForecastAward"] = 10] = "ForecastAward";
  BonusEvents2[BonusEvents2["CompPointsExchange"] = 11] = "CompPointsExchange";
  return BonusEvents2;
})(BonusEvents || {});
var BonusesBonusTypes = /* @__PURE__ */ ((BonusesBonusTypes2) => {
  BonusesBonusTypes2[BonusesBonusTypes2["Bonus"] = 1] = "Bonus";
  BonusesBonusTypes2[BonusesBonusTypes2["Cashback"] = 2] = "Cashback";
  BonusesBonusTypes2[BonusesBonusTypes2["Freespins"] = 3] = "Freespins";
  BonusesBonusTypes2[BonusesBonusTypes2["FreeBet"] = 4] = "FreeBet";
  BonusesBonusTypes2[BonusesBonusTypes2["CompPoints"] = 6] = "CompPoints";
  BonusesBonusTypes2[BonusesBonusTypes2["RiskFreeSpin"] = 7] = "RiskFreeSpin";
  BonusesBonusTypes2[BonusesBonusTypes2["RiskFreeBet"] = 8] = "RiskFreeBet";
  BonusesBonusTypes2[BonusesBonusTypes2["RandomPrize"] = 9] = "RandomPrize";
  BonusesBonusTypes2[BonusesBonusTypes2["BonusBuy"] = 12] = "BonusBuy";
  return BonusesBonusTypes2;
})(BonusesBonusTypes || {});
var BonusFreeBetTypes = /* @__PURE__ */ ((BonusFreeBetTypes2) => {
  BonusFreeBetTypes2[BonusFreeBetTypes2["Full"] = 1] = "Full";
  BonusFreeBetTypes2[BonusFreeBetTypes2["Gain"] = 2] = "Gain";
  BonusFreeBetTypes2[BonusFreeBetTypes2["Base"] = 3] = "Base";
  return BonusFreeBetTypes2;
})(BonusFreeBetTypes || {});
var BonusIssuanceTypes = /* @__PURE__ */ ((BonusIssuanceTypes2) => {
  BonusIssuanceTypes2[BonusIssuanceTypes2["DISABLED"] = 0] = "DISABLED";
  BonusIssuanceTypes2[BonusIssuanceTypes2["ENABLED"] = 1] = "ENABLED";
  return BonusIssuanceTypes2;
})(BonusIssuanceTypes || {});
var BasePromotionType = /* @__PURE__ */ ((BasePromotionType2) => {
  BasePromotionType2[BasePromotionType2["bonus"] = 0] = "bonus";
  BasePromotionType2[BasePromotionType2["tournament"] = 1] = "tournament";
  BasePromotionType2[BasePromotionType2["lottery"] = 2] = "lottery";
  BasePromotionType2[BasePromotionType2["previousTournament"] = 4] = "previousTournament";
  BasePromotionType2[BasePromotionType2["prizeDrops"] = 5] = "prizeDrops";
  return BasePromotionType2;
})(BasePromotionType || {});
var BonusTypes = /* @__PURE__ */ ((BonusTypes2) => {
  BonusTypes2[BonusTypes2["sports"] = 1] = "sports";
  BonusTypes2[BonusTypes2["casino"] = 2] = "casino";
  BonusTypes2[BonusTypes2["vip"] = 3] = "vip";
  BonusTypes2[BonusTypes2["all"] = 0] = "all";
  return BonusTypes2;
})(BonusTypes || {});
export {
  BasePromotionType,
  BonusEvents,
  BonusFieldNames,
  BonusFreeBetTypes,
  BonusIssuanceTypes,
  BonusTypes,
  BonusesBonusTypes
};
